.slot {
  position: absolute;
  z-index: 2;
  translate: -50% -50%;
}

.slot[data-placed='true'] {
  filter: drop-shadow(0 10px 12px rgb(0 0 0 / 0.35));
}

.paused {
  position: absolute;
  z-index: 2;
  translate: -50% -50%;
  padding: 3px 10px;
  border-radius: 999px;
  border: 1px dashed rgb(255 255 255 / 0.4);
  background: rgb(0 0 0 / 0.3);
  color: rgb(255 255 255 / 0.75);
  font-size: 0.75rem;
  white-space: nowrap;
}
